// BUILD-042 — HR Administration unified layout. Honest Planned placeholder for the four
// admin-setup destinations with no backend yet (Benefit plans, Training catalog, Document
// templates, Time-off policies), matching the reference's tile grid + "what HR will configure"
// preview list + company-config-vs-per-employee-assignment distinction. No fake saves, no
// invented counts — every row below is explicitly labeled Planned, not rendered as if it works.
import { CardTitle, PlannedBadge } from './SectionHeading';

export interface AdminPlannedContent {
  title: string;
  subtitle: string;
  tiles: string[];
  settingsFields: string[];
  note: string;
}

export function AdminPlannedPanel({ content }: { content: AdminPlannedContent }) {
  return (
    <div>
      <div className="flex items-start justify-between gap-3 mb-5">
        <div>
          <h1 className="text-xl font-bold text-gray-900 leading-tight">{content.title}</h1>
          <p className="text-sm text-gray-500 mt-1">{content.subtitle}</p>
        </div>
        <PlannedBadge />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
        {content.tiles.map((t) => (
          <div key={t} className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 text-left">
            <div className="text-sm font-semibold text-gray-900">{t}</div>
            <div className="text-xs text-gray-500 mt-1">Setup and configuration</div>
            <div className="text-xs text-[#4AABDE] mt-2">Explore planned setup →</div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 mb-4">
        <CardTitle>What HR will configure</CardTitle>
        <ul className="divide-y divide-gray-100">
          {content.settingsFields.map((f) => (
            <li key={f} className="flex items-center justify-between py-2.5 first:pt-0">
              <span className="text-sm text-gray-700">{f}</span>
              <span className="text-xs text-gray-400 border border-gray-200 rounded px-1.5 py-0.5">Planned</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-[#EDF5FC] rounded-md px-3 py-2.5 text-xs text-gray-700">
        {content.note}. These setup screens do not yet save plans, policies, training, or documents.
      </div>

      <details className="text-xs text-gray-500 mt-4">
        <summary className="text-[#4AABDE] cursor-pointer">How this page works</summary>
        <p className="mt-2 max-w-lg">
          Company configuration belongs here. Individual eligibility, assignments, and acknowledgments belong in each employee's own record. Changes need effective dates and preserved prior versions rather than silently replacing old arrangements.
        </p>
      </details>
    </div>
  );
}
